<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col cols="12" :class="$vuetify.breakpoint.smAndDown ? 'px-1' : ''">
          <v-sheet elevation="0">
            <v-slide-group
              class="pa-4 items-group-class"
              active-class="#6c5dd4"
              show-arrows
            >
              <v-slide-item
                class="rounded-lg"
                v-for="user_role in UsersCount"
                :key="user_role"
                v-slot="{ active, toggle }"
              >
                <v-card
                  :color="active ? '#6c5dd4' : '#f1f2f6'"
                  elevation="0"
                  class="ma-4"
                  height="100"
                  width="220"
                  @click="toggle"
                >
                  <v-row
                    class="fill-height px-3"
                    align="center"
                    justify="center"
                  >
                    <v-scale-transition>
                      <v-col class="d-flex pl-1">
                        <v-col cols="3" class="mt-2">
                          <span
                            class="px-2 py-3 rounded-xl mr-3"
                            :color="active ? 'white' : 'black'"
                            :style="{
                              'background-color': active ? 'white' : '#6c5dd4',
                            }"
                            widht="10px"
                          >
                            <v-icon
                              size="25"
                              :color="active ? 'black' : 'white'"
                              >mdi-{{ user_role.icon }}</v-icon
                            >
                          </span>
                        </v-col>
                        <v-col cols="10">
                          <span
                            :class="[
                              'text-h5',
                              active ? 'white--text' : 'black--text',
                            ]"
                            >{{ user_role.count }}</span
                          >
                          <br />
                          <span
                            :class="[
                              'text-caption',
                              active ? 'white--text' : 'black--text',
                            ]"
                            >Total {{ user_role.name }} counts
                          </span>
                        </v-col>
                      </v-col>
                    </v-scale-transition>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          md="12"
          :class="$vuetify.breakpoint.smAndDown ? 'px-1' : ''"
          class="pt-0"
        >
          <v-card elevation="0">
            <v-card-title class="pb-0">
              <v-col cols="12" class="px-0 pb-1 pt-0">
                <v-col cols="12" class="py-0">
                  <span class="text-h6">Total users count ({{ count }})</span>
                </v-col>
                <v-sheet max-width="700">
                  <v-slide-group v-model="activeIndex" show-arrows>
                    <v-slide-item
                      v-for="(user_role, index) in UsersCount"
                      :key="index"
                      v-slot="{ active }"
                    >
                      <vs-button
                        class="mx-1"
                        :input-value="active"
                        :class="active ? 'white--text' : 'black--text'"
                        :style="{
                          'background-color': active ? '#6c5dd4' : '#f1f2f6',
                        }"
                        depressed
                        @click="getData(user_role, index)"
                      >
                        <span class="text-caption"
                          >{{ user_role.name }} ({{ user_role.count }})</span
                        >
                      </vs-button>
                    </v-slide-item>
                  </v-slide-group>
                </v-sheet>
              </v-col>
              <vs-button
                class="mx-2 text-caption"
                color="#6c5dd4"
                @click="createformdialog = true"
                >+ Add User</vs-button
              >
              <v-spacer></v-spacer>
              <vs-pagination
                v-model="page"
                color="#6c5dd4"
                :length="paginationLength"
              >
              </vs-pagination>
              <vs-input
                class="search-field-input text-caption"
                v-model="search_keyword"
                placeholder="Search ... "
                prepend-inner-icon="mdi-magnify"
                @keydown.enter="getData"
                @change="page = 1"
                clearable
              ></vs-input>
              <vs-button
                v-if="users.length != 0"
                :class="[
                  $vuetify.breakpoint.smAndDown ? 'ml-8' :  'mx-4',
                  'text-caption',
                ]"
                color="#6c5dd4"
                :loading="isExcelLoading"
                :disabled="isExcelLoading"
                @click="generateExcel()"
                >Generate Excel</vs-button
              >
            </v-card-title>
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="#6c5dd4"
              dark
            ></v-progress-linear>
            <v-simple-table fixed-header height="600">
              <template v-slot:default> 
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Role</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Phone</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody v-if="users.length != 0">
                  <tr v-for="(user, i) in users" :key="`user${i}`">
                    <td style="min-width: 85px">
                      <v-tooltip bottom v-if="user.active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="green"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>User is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="user.active == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>User is InActive</span>
                      </v-tooltip>
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td>{{ user.roles[0] ? user.roles[0].name : "" }}</td>
                    <td>{{ user.name || "" }}</td>
                    <td>{{ user.email || "" }}</td>
                    <td>{{ user.phone || "" }}</td>
                    <td class="text-center">
                      <v-btn
                        class="mx-2"
                        elevation="0"
                        fab
                        x-small
                        color="#6c5dd4"
                        dark
                        @click="getUserData(user.id)"
                      >
                        <v-icon size="15"> mdi-pencil </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="12" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- create dialog -->
      <vs-dialog
        v-model="createformdialog"
        :loading="isFormLoading"
        class="admin-create"
      >
        <v-row class="con-form">
          <v-col cols="12">
            <span class="text-h6"> Enter a basic detils </span>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Name * </label>
            <vs-input
              primary
              v-model="Createform.name"
              placeholder="Name"
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-account"></i>
              </template>

              <template #message-danger>
                {{ errors && errors.name ? errors.name : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Mobile no * </label>
            <vs-input
              primary
              v-model="Createform.phone"
              placeholder="Enter a mobile no."
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-phone"></i>
              </template>

              <template #message-danger>
                {{ errors && errors.phone ? errors.phone : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Email * </label>
            <vs-input
              primary
              v-model="Createform.email"
              placeholder="Enter a email *"
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-email"></i>
              </template>

              <template #message-danger>
                {{ errors && errors.email ? errors.email : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="mt-3">
            <label for="">Select role</label>
            <v-autocomplete
              class="role-autocomplete"
              elevation="0"
              v-model="Createform.role_id"
              :items="roles"
              dense
              label="Select Role"
              solo
              :error-messages="errors.role_id"
            ></v-autocomplete>
          </v-col>
          <v-col
            xl="6"
            lg="6"
            md="6"
            sm="12"
            cols="12"
            class="px-1 d-flex align-center mt-4"
          >
            <label for="" class="text-caption">Is Active</label>
            <v-col cols="3">
              <vs-switch v-model="Createform.active">
                <template #off> No </template>

                <template #on> Yes </template>
              </vs-switch>
            </v-col>
          </v-col>
        </v-row>

        <template #footer>
          <div class="footer-dialog">
            <vs-button
              color="#6c5dd4"
              style="padding: 0px 23px; float: right"
              :loading="isFormLoading"
              @click="save"
            >
              Save User
            </vs-button>
          </div>
        </template>
      </vs-dialog>
      <!-- //edit dialog -->
      <vs-dialog
        v-model="Editformdialog"
        :loading="isFormLoading"
        class="admin-create"
      >
        <v-row class="con-form">
          <v-col cols="12">
            <span class="text-h6"> Edit a basic detils </span>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Name * </label>
            <vs-input
              primary
              v-model="Editform.name"
              placeholder="Email"
              icon-after
              block
            >
              <template #icon> @ </template>

              <template #message-danger>
                {{ errors && errors.name ? errors.name : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Mobile no * </label>
            <vs-input
              primary
              v-model="Editform.phone"
              placeholder="Enter a mobile no."
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-phone"></i>
              </template>

              <template #message-danger>
                {{ errors && errors.phone ? errors.phone : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Email * </label>
            <vs-input
              primary
              v-model="Editform.email"
              placeholder="Enter a email *"
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-email"></i>
              </template>

              <template #message-danger>
                {{ errors && errors.email ? errors.email : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="mt-3">
            <label for="">Select role</label>
            <v-autocomplete
              class="role-autocomplete"
              elevation="0"
              v-model="Editform.role_id"
              :items="roles"
              dense
              label="Select Role"
              solo
              :error-messages="errors.error_id"
            ></v-autocomplete>
          </v-col>
          <v-col
            xl="6"
            lg="6"
            md="6"
            sm="12"
            cols="12"
            class="px-1 d-flex align-center mt-4"
          >
            <label for="" class="text-caption">Is Active</label>
            <v-col cols="3">
              <vs-switch v-model="Editform.active">
                <template #off> No </template>

                <template #on> Yes </template>
              </vs-switch>
            </v-col>
          </v-col>
        </v-row>
        <template #footer>
          <div class="footer-dialog">
            <vs-button
              color="#6c5dd4"
              :loading="isFormLoading"
              @click="update(Editform.id)"
              class="float-end"
              style="padding: 0px 23px; float: right"
            >
              Edit User
            </vs-button>
          </div>
        </template>
      </vs-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "usersPage",
  data() {
    return {
      Createform: {
        active: true,
      },
      Editform: {
        active: "",
      },
      filter: {
        active: "",
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      users: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      Companies: [],
      roles: [],
      isLoading: false,
      isFormLoading: false,
      isExcelLoading: false,
      createformdialog: false,
      Editformdialog: false,
      value: "",
      TotalAdmincount: 0,
      TotalSubVendorcount: 0,
      TotalUsercount: 0,
      UsersCount: [],
      activeIndex: 0,
    };
  },
  watch: {
    page: "getData",
  },
  created() {
    if (this.UsersCount.length > 0) {
      this.UsersCount[0].active = true;
    }
  },
  mounted() {
    if (this.roleName == "Super Admin") {
      this.companyId = this.$store.getters["settings/getCompanyId"];
    }
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = "";
      if (this.roleName == "Super Admin") {
        const config = {
          headers: {
            "Company-id": this.companyId,
          },
        };
        masters = await axios.get(`users/masters`, config);
      } else {
        masters = await axios.get(`users/masters`);
      }
      masters = masters.data;
      //roles
      masters.rolesResponse.forEach((role) => {
        if (this.roleName == "Admin") {
          if (role.id != 2) {
            this.roles.push({
              id: role.id,
              text: role.name,
              value: role.id,
            });
          }
        } else if (this.roleName == "Sub Vendor") {
          if (role.id != 3 && role.id != 2) {
            this.roles.push({
              id: role.id,
              text: role.name,
              value: role.id,
            });
          }
        } else {
          this.roles.push({
            id: role.id,
            text: role.name,
            value: role.id,
          });
        }
      });
      this.getData();
    },
    async getData(user_role , index) {
      if(index != null){
        this.activeIndex = index;
      }
      this.isLoading = true;
      if (this.roleName == "Admin" || this.roleName == "Sub Vendor") {
        this.logged_in_user_role_id = this.user.id;
      }
      this.role_id =
        user_role != null && user_role.id != null ? user_role.id : "";
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.filter.active = this.filter.active ? this.filter.active : "";
      this.logged_in_user_role_id = this.logged_in_user_role_id
        ? this.logged_in_user_role_id
        : "";
      let users = [];
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.filter.active +
        "&logged_in_role_id=" +
        this.logged_in_user_role_id +
        "&roleId=" +
        this.role_id;

      if (this.roleName == "Super Admin") {
        const config = {
          headers: {
            "Company-id": this.companyId,
          },
        };
        users = await axios.get(`users?${query}`, config);
      } else {
        users = await axios.get(`users?${query}`);
      }
      this.users = users.data.data;
      this.count = users.data.count;
      if (user_role == null || user_role.id == null) {
        const roleCounts = {
          role2: 0,
          role3: 0,
          role4: 0,
        };

        this.users.forEach((user) => {
          user.roles.forEach((role) => {
            if (role.id == 2) {
              roleCounts.role2++;
            } else if (role.id == 3) {
              roleCounts.role3++;
            } else if (role.id == 4) {
              roleCounts.role4++;
            }
          });
        });
        this.UsersCount = [
          { name: "All", count: this.count, icon: "counter" },
          ...(this.roleName == "Super Admin"
            ? [
                {
                  id: 2,
                  name: "Admins",
                  count: roleCounts.role2,
                  icon: "shield-crown",
                },
              ]
            : []),
          ...(this.roleName != "Sub Vendor"
            ? [
                {
                  id: 3,
                  name: "Sub-Vendors",
                  count: roleCounts.role3,
                  icon: "account-supervisor",
                },
              ]
            : []),
          {
            id: 4,
            name: "Users",
            count: roleCounts.role4,
            icon: "account-group",
          },
        ];
      }
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },
    async getUserData(AdminId) {
      let form = await axios.get(`/users/${AdminId}`);
      this.Editform = form.data.data;
      this.Editform.active = this.Editform.active ? true : false;
      this.Editform.company_id = this.Editform.companies[0].id
        ? this.Editform.companies[0].id
        : "";
      this.Editform.role_id = this.Editform.roles[0].id
        ? this.Editform.roles[0].id
        : "";
      this.Editformdialog = true;
    },
    async update(adminId) {
      this.isFormLoading = true;
      try {
        let admin = await axios.patch(`/users/${adminId}`, this.Editform);
        this.Editform = admin.data.data;
        this.isFormLoading = false;
        this.Editformdialog = false;
        this.getData();
      } catch (e) {
        this.isFormLoading = false;
      }
    },
    async save() {
      try {
        this.isFormLoading = true;
        if (this.roleName == "Super Admin") {
          const config = {
            headers: {
              "Company-id": this.companyId,
            },
          };
          await axios.post("/users", this.Createform, config);
        } else {
          await axios.post("/users", this.Createform);
        }
        this.isFormLoading = false;
        this.createformdialog = false;
        (this.Createform = { active: true }), this.getData();
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.errors = error.response.data.errors;
          this.isFormLoading = false;
        } else {
          console.error("Error saving admin:", error);
          this.isFormLoading = false;
        }
      }
    },
    async generateExcel() {
      this.isExcelLoading = true;
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.filter.active +
        "&roleId=" +
        this.role_id;

      try {
        let response = '';
        const config = {
          headers: {
            "Company-id": this.companyId,
          },
        };
        if(this.roleName == 'Super Admin') {
          response = await axios.get(`usersExports?${query}`, config);
        }else{
          response = await axios.get(`usersExports?${query}`);
        }
        if (response && response.data && response.data.data) {
          window.open(`${response.data.data}`, "_blank");
          this.isExcelLoading = false;
        } else {
          console.error("Invalid response data:", response.data);
          this.isExcelLoading = false;
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
        this.isExcelLoading = false;
      }
    },
    async Delete_this(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.delete(`users/${id}`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>

<style>
tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}

.admin-create .vs-createform {
  width: 861px;
}

.items-group-class .v-slide-group__next,
.v-slide-group__prev {
  min-width: 7px !important;
}

.role-autocomplete .v-input__slot,
.companies-autocomplete .v-input__slot {
  box-shadow: none !important;
  background: #f4f7f8 !important;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
  border-radius: 10px;
}
</style>
